import {classNames, observer, React, useEffect} from '@api'
import {Menu} from '@blueprintjs/core'
import {FlexLayoutComponentProps, useCatalog} from '@stores'
import {FlexLayoutDockMenuItems, FlexToolboxMenuItems} from '@stores/catalog/flexLayout'
import {CollapsibleStateful} from 'centric-ui-components'
import * as css from './FlexLayoutToolboxTabWindow.css'

export const FlexLayoutToolboxTabWindow = observer<FlexLayoutComponentProps>(function FlexLayoutToolboxWindow(props) {
  const {filter} = useCatalog()

  useEffect(() => {
    filter.everVisible = true
  }, [filter.everVisible])

  // console.log(props)

  return (<div className={classNames(props.className, css.root)}>
    <CollapsibleStateful title={`Toolbox`}>
      <Menu>
        <FlexToolboxMenuItems />
      </Menu>
    </CollapsibleStateful>
    <CollapsibleStateful title={`Dock`}>
      <Menu>
        <FlexLayoutDockMenuItems/>
      </Menu>
    </CollapsibleStateful>
  </div>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/toolbox-items/FlexLayoutToolboxTabWindow.tsx